import { c as _c } from "react/compiler-runtime";
import type { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateConfigHeader from "../GroupCreateConfigHeader";
import GroupCreateCIC from "./GroupCreateCIC";
import GroupCreateLevel from "./GroupCreateLevel";
import GroupCreateRep from "./GroupCreateRep";
import GroupCreateTDH from "./GroupCreateTDH";
import GroupCreateCollections from "./nfts/GroupCreateCollections";
import GroupCreateNfts from "./nfts/GroupCreateNfts";
import GroupCreateXtdhGrant from "./xtdh-grant/GroupCreateXtdhGrant";
import GroupCreateWallets, { GroupCreateWalletsType } from "./wallets/GroupCreateWallets";
export default function GroupCreateConfig(t0) {
  const $ = _c(40);
  const {
    level,
    tdh,
    cic,
    rep,
    wallets,
    excludeWallets,
    nfts,
    beneficiaryGrantId,
    iAmIncluded,
    setLevel,
    setTDH,
    setCIC,
    setRep,
    setWallets,
    setExcludeWallets,
    setNfts,
    setBeneficiaryGrantId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GroupCreateConfigHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== level || $[2] !== setLevel) {
    t2 = <GroupCreateLevel level={level} setLevel={setLevel} />;
    $[1] = level;
    $[2] = setLevel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setTDH || $[5] !== tdh) {
    t3 = <GroupCreateTDH tdh={tdh} setTDH={setTDH} />;
    $[4] = setTDH;
    $[5] = tdh;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cic || $[8] !== setCIC) {
    t4 = <GroupCreateCIC cic={cic} setCIC={setCIC} />;
    $[7] = cic;
    $[8] = setCIC;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== rep || $[11] !== setRep) {
    t5 = <GroupCreateRep rep={rep} setRep={setRep} />;
    $[10] = rep;
    $[11] = setRep;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] !== nfts || $[14] !== setNfts) {
    t6 = <GroupCreateNfts nfts={nfts} setNfts={setNfts} />;
    t7 = <GroupCreateCollections nfts={nfts} setNfts={setNfts} />;
    $[13] = nfts;
    $[14] = setNfts;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  let t8;
  if ($[17] !== beneficiaryGrantId || $[18] !== setBeneficiaryGrantId) {
    t8 = <GroupCreateXtdhGrant beneficiaryGrantId={beneficiaryGrantId} setBeneficiaryGrantId={setBeneficiaryGrantId} />;
    $[17] = beneficiaryGrantId;
    $[18] = setBeneficiaryGrantId;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <div className="tw-col-span-full tw-space-y-4 sm:tw-space-y-5">{t1}<div className="tw-grid tw-grid-cols-1 tw-gap-x-6 tw-gap-y-4 sm:tw-gap-y-6 lg:tw-grid-cols-2">{t2}{t3}{t4}{t5}{t6}{t7}{t8}</div></div>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== iAmIncluded || $[29] !== setWallets || $[30] !== wallets) {
    t10 = <GroupCreateWallets type={GroupCreateWalletsType.INCLUDE} iAmIncluded={iAmIncluded} wallets={wallets} setWallets={setWallets} walletsLimit={10000} />;
    $[28] = iAmIncluded;
    $[29] = setWallets;
    $[30] = wallets;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== excludeWallets || $[33] !== iAmIncluded || $[34] !== setExcludeWallets) {
    t11 = <GroupCreateWallets type={GroupCreateWalletsType.EXCLUDE} wallets={excludeWallets} iAmIncluded={iAmIncluded} setWallets={setExcludeWallets} walletsLimit={1000} />;
    $[32] = excludeWallets;
    $[33] = iAmIncluded;
    $[34] = setExcludeWallets;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t9) {
    t12 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-6 sm:tw-gap-y-8">{t9}{t10}{t11}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t9;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
}